var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.811 2.084L9.909 6.986v7.378a.644.644 0 0 1-.387.587.743.743 0 0 1-.25.049.592.592 0 0 1-.447-.189L6.28 12.266a.63.63 0 0 1-.189-.447V6.986L1.19 2.084a.626.626 0 0 1-.14-.696c.1-.229.329-.388.587-.388h12.727c.258 0 .487.16.586.389a.626.626 0 0 1-.139.695"}));
}

Filter.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Filter;

Filter.default = Filter;
